<template>
  <div>
  <!-- <b-container title="Agenda de Prazos" style="width: 100%;"> -->
    <div class="d-flex align-items-center bloco-fixo bg-gray-200">
      <b-col>
        <h1 class="app-title">
          Agenda de Prazos / {{ procurador.name }} ({{procurador.grupoTrabalho}})
        </h1>
      </b-col>
      <b-col sm="12" lg="auto">
        <div style="text-align: right;">
          <span class="right">Última sincronização: {{ formatarDataHora(procurador.dataHoraUltimaSincronizacao) }}</span>
        </div>
        <ToolbarAgenda :perfil="perfil" :itensSelecionados="itensSelecionados" />
      </b-col>
    </div>
    <b-card>
      <div class="mb-2 bloco-fixo-abas bg-white">
        <b-row class="d-flex justify-content-left">
          <b-col md="4">
            <div>
              <b-button class="mr-2" @click="voltar()" variant="secondary">
                <i class="fa fa-arrow-left"></i>
                Voltar
              </b-button>
              <b-form-select
                v-model="perPage"
                :options="[100, 250, 500]"
                size="sm"
                class="mr-2 col-2"
              >
              </b-form-select>
              <b-button class="mr-2" @click="limparFiltros()" variant="secondary">
                <i class="fa fa-eraser"></i>
                Limpar Filtros
              </b-button>
            </div>

          </b-col>

          <b-col class="center-xy mt-0">
            <b-button-group class="botoes-tabelas">
              <b-button
                variant="outline-secondary"
                :class="{ active: perfil === 'prazo' }"
                @click="perfil = 'prazo'"
                class="flex-fill btn-prazo"
                >Prazo</b-button
              >
              <b-button
                variant="outline-secondary"
                :class="{ active: perfil === 'processo' }"
                @click="perfil = 'processo'"
                class="flex-fill btn-processo"
                >Processo e Devedor</b-button
              >
              <b-button
                variant="outline-secondary"
                :class="{ active: perfil === 'minuta' }"
                @click="desselecionarPrazos();consultarModelos();perfil = 'minuta';"
                class="flex-fill btn-minuta"
                >Minuta</b-button
              >
            </b-button-group>
          </b-col>
        </b-row>
      </div>
      <div>
        <AgendaPrazosTabela 
          ref="agendaPrazosTabelaRef"
          :perfil="perfil"
          :per-page="perPage"
          :filtros="filtros"
          :sort-field="sortField"
          :itensSelecionados="itensSelecionados"
          @openFilterPopup="openFilterPopup"
          @atualizarSelecionados="atualizarSelecionados"
        />
      </div>
      
    </b-card>
    <CompFiltroGrid
        ref="compFiltro"
        :filtro="filtro"
        @filtrarResultados="filtrarResultados"
        @ordenarResultados="ordenarResultados"
      />

  </div>
  <!-- </b-container> -->
</template>

<script>

import ToolbarAgenda from "@/components/toolbar-agenda/ToolbarAgenda.vue";
import AgendaPrazosTabela from "./components/AgendaPrazosTabela.vue";
import CompFiltroGrid from "../shared/components/CompFiltroGrid.vue";
import formatarMixins from '../../mixins/formatarMixins';

const StatusPrazoEnum = Object.freeze({
  PENDENTE_CIENCIA: "Aguardando Leitura",
  PENDENTE_RESPOSTA: "Aberto",
  CUMPRIDO: "Cumprido"
})

export default {
  mixins: [formatarMixins],
  components: {
    CompFiltroGrid,
    AgendaPrazosTabela,
    ToolbarAgenda,
  },
  data() {
    return {
      // perfilPrazo: true,
      // perfilProcesso: false,
      // perfilMinuta: false,
      itensSelecionados: [],
      filtro: {
          tipo: null,
          campoFiltro: null,
          tribunal: [],
          sistemaFonte: [],
          filtrarEm: null,
          campoValor: null,
          campoMascara: null,
          listaValores: []
        },
      filtros:{
        cnj: null,
        tipoPrazo: null,
      },
      toggleBtnPerfil: false,
      perfil: "prazo",
      exibir: false,
      taxa: "",
      taxas: [
        { descricao: "00 à 99 - 5%", valor: 5 },
        { descricao: "100 à 999 - 10%", valor: 10 },
        { descricao: "999 à 1000 - 20%", valor: 20 },
      ],
      tipoParcelamento: null,
      modalidadePgto: null,
      indiceReajuste: null,
      tipoPgto1: null,
      tipoPgto2: null,
      tipoPgto3: null,
      radioTipoPgto: null,
      selectedPercentual1: null,
      selectedPercentual2: null,
      selectedFormaPgto: null,
      "radio-sub-component": null,
      tipoRegra: "refis",
      pgtoHonorarios: null,
      tipoPgto: null,
      modPagamentos: [
        { value: null, text: "Selecionar" },
        { value: "1", text: "À Vista - 5% (art. 7º da Lei n 18.292/2014)" },
        { value: "2", text: "À Vista - 2% (art. 3º da Lei n 17.341/2021)" },
        { value: "3", text: "Parc - Delib 4.526/2020" },
      ],
      itemsPercentual: [
        { value: null, text: "Selecionar" },
        { value: "5", text: "Refis à Vista" },
        { value: "10", text: "Refis 6 parcelas" },
        { value: "15", text: "Refis 12 parcelas" },
        { value: "20", text: "Refis 24 parcelas" },
        { value: "20", text: "Refis 36 parcelas" },
      ],
      itemsFormaPgto1: [
        { value: null, text: "Selecionar" },
        { value: 0, text: "Honorários à vista" },
        { value: 3, text: "Honorários 3 parcelas" },
        { value: 6, text: "Honorários 6 parcelas" },
        { value: 12, text: "Honorários 12 parcelas" },
      ],
      itemsFormaPgto2: [
        { value: null, text: "Selecionar" },
        { value: 0, text: "Honorários à vista" },
        { value: 3, text: "Honorários 3 parcelas" },
        { value: 6, text: "Honorários 6 parcelas" },
        { value: 12, text: "Honorários 12 parcelas" },
      ],
      itemsFormaPgto3: [
        { value: null, text: "Selecionar" },
        { value: 1, text: "Transferência Eletrônica" },
        { value: 2, text: "Boleto" },
      ],
      indicesReajuste: [
        { value: null, text: "Selecionar" },
        { value: "5", text: "Média INPC - IGP-DI + 1%a.m." },
      ],
      selecao: null,
      scrollPosition: null,
      selecionados: [],
      todosSelecionados: false,
      perPage: 100,
      sortField: "",
      collapseHistorico: false,
    };
  },
  computed: {
    toggleAvancar() {
      return this.selecionados.length === 0;
    },
    visibleFields() {
      return this.fields.filter((field) => field.perfil === this.perfil);
    },
    procurador() {
      return this.$store.getters.getAgendaProcurador;
    }
  },
  methods: {
    setPerfilPrazo() {
      this.perfilPrazo = true;
      this.perfilProcesso = false;
      this.perfilMinuta = false;
    },
    setPerfilProcesso() {
      this.perfilPrazo = false;
      this.perfilProcesso = true;
      this.perfilMinuta = false;
    },
    setPerfilMinuta() {
      this.perfilPrazo = false;
      this.perfilProcesso = false;
      this.perfilMinuta = true;
    },
    selecionarCnj(cnj) {
      this.items.forEach(function(item) {
        if (item.cnj === cnj) {
          item.selecao = !item.selecao;
        }
      });
    },
    voltar() {
      this.$router.push("/agenda");  
    },
    avancar() {
      // this.$emit("avancar");
      alert('Limpar filtros da grid')
    },
    selecionar(item) {
      if (item.selecao) {
        this.selecionados.push(item);
      } else {
        this.selecionados.pop(item);
      }
    },
    selecionarTudo() {
      this.selecionados = [];
      this.items.forEach((item) => {
        item.selecao = this.todosSelecionados;
        if (this.todosSelecionados) {
          this.selecionados.push(item);
        }
      });
    },
    imprimir() {
      window.open(
        "http://beta.pr.gov.br/sistemas/pge/docs/ReceitaDiversa.pdf",
        "_blank"
      );
    },
    openFilterPopup(campo, tipo, values, mascara, event) {
        if(document.getElementById('popup').style.display == 'block'
            && this.filtro.campoFiltro == campo) {
            this.$refs.compFiltro.closeFilterPopup();
        } else {
            this.filtro.tipo = tipo;
            this.filtro.campoFiltro = campo;
            this.filtro.mascara = mascara;

	        if(this.filtro.campoFiltro == 'CNJ') {
		        this.filtro.campoMascara = this.filtros.cnj;
	        } else if(this.filtro.campoFiltro == 'Tipo Prazo') {
		        this.filtro.campoValor = this.filtros.tipoPrazo;
	        } else if(this.filtro.campoFiltro == 'Status Prazo') {
		        this.filtro.campoValor = []
		        if (this.filtros.statusPrazo) {
			        this.filtros.statusPrazo.forEach(el => {
				        this.filtro.campoValor = [...this.filtro.campoValor, StatusPrazoEnum[el]]
			        });
		        }
	        } else if(this.filtro.campoFiltro == 'Data de Envio') {
		        this.filtro.filtrarEm = this.filtros.tipoFiltroDataEnvio;
		        this.filtro.campoValor = this.filtros.dataEnvio;
	        } else if(this.filtro.campoFiltro == 'Data Leitura') {
		        this.filtro.filtrarEm = this.filtros.tipoFiltroDataAbertura;
		        this.filtro.campoValor = this.filtros.dataAbertura;
	        } else if(this.filtro.campoFiltro == 'Data Venc.') {
		        this.filtro.filtrarEm = this.filtros.tipoFiltroDataVenc;
		        this.filtro.campoValor = this.filtros.dataVenc;
	        } else if(this.filtro.campoFiltro == 'Meu Venc.') {
		        this.filtro.filtrarEm = this.filtros.tipoFiltroMeuVenc;
		        this.filtro.campoValor = this.filtros.meuVenc;
	        } else if(this.filtro.campoFiltro == 'Dias Prazo') {
		        this.filtro.filtrarEm = this.filtros.tipoFiltroDiasPrazo;
		        this.filtro.campoValor = this.filtros.diasPrazo;
	        } else if(this.filtro.campoFiltro == 'Teor da Comunicação') {
		        this.filtro.filtrarEm = this.filtros.tipoFiltroTeorComunicacao;
		        this.filtro.campoValor = this.filtros.teorComunicacao;
	        } else if(this.filtro.campoFiltro == 'Classe Processual') {
		        this.filtro.filtrarEm = this.filtros.tipoFiltroClasseProcessual;
		        this.filtro.campoValor = this.filtros.classeProcessual;
	        } else if(this.filtro.campoFiltro == 'Data Aju.') {
		        this.filtro.filtrarEm = this.filtros.tipoFiltroDataAju;
		        this.filtro.campoValor = this.filtros.dataAju;
	        } else if(this.filtro.campoFiltro == 'Status Grau') {
		        this.filtro.filtrarEm = this.filtros.tipoFiltroStatusGrau;
		        this.filtro.campoValor = this.filtros.statusGrau;
	        } else if(this.filtro.campoFiltro == 'Devedor') {
		        this.filtro.filtrarEm = this.filtros.tipoFiltroDevedor;
		        this.filtro.campoValor = this.filtros.devedor;
	        } else if (this.filtro.campoFiltro == 'Minuta') {
		        this.filtro.campoValor = this.filtros.minuta == null ? null : (this.filtros.minuta ? 'Sim' : 'Não');
	        } else if (this.filtro.campoFiltro == 'Modelo Utilizado') {
		        this.filtro.filtrarEm = this.filtros.tipoFiltroModelo;
		        this.filtro.campoValor = this.filtros.modelo;
	        } else if (this.filtro.campoFiltro == 'Rel. CDAs') {
		        this.filtro.campoValor = this.filtros.relCdas;
	        } else if (this.filtro.campoFiltro == 'Anexos') {
		        this.filtro.campoValor = this.filtros.anexos == null ? null : (this.filtros.anexos ? 'Sim' : 'Não');
	        } else if (this.filtro.campoFiltro == 'Status da Minuta') {
		        this.filtro.campoValor = this.filtros.statusMinuta;
	        } else if (this.filtro.campoFiltro == 'ID Aviso') {
		        this.filtro.filtrarEm = this.filtros.tipoIdAviso;
            this.filtro.campoValor = this.filtros.idAviso;
	        }

            if(this.filtro.tipo == "checkbox" || this.filtro.tipo == "radio" || this.filtro.tipo == "combo") {
                this.filtro.listaValores = values;
            } else if(values != null && values != "") {
                this.filtro.listaValores = values.split(',');
            }

            this.$refs.compFiltro.openCloseFilterPopup(event);
        }
    },
    filtrarResultados(limpar) {
        if(limpar) {
            this.filtro.filtrarEm = null;
            this.filtro.campoValor = null;
            this.filtro.campoMascara = null;
            
            if(this.filtro.campoFiltro == 'CNJ') {
              this.filtro.tribunal = [];
              this.filtro.sistemaFonte = [];
            }
        }

        if(this.filtro.campoFiltro == 'CNJ') {
            this.filtros.cnj = this.filtro.campoMascara;
            this.filtros.tribunal = this.filtro.tribunal;
            this.filtros.sistemaFonte = this.filtro.sistemaFonte;

        } else if(this.filtro.campoFiltro == 'Tipo Prazo') {
          this.filtros.tipoPrazo = this.filtro.campoValor;

        } else if(this.filtro.campoFiltro == 'Status Prazo') {
          this.filtros.statusPrazo = []

          if (this.filtro.campoValor !== null) {
            this.filtro.campoValor.forEach(cv => {
              const statusEnum = Object.keys(StatusPrazoEnum).filter(key => StatusPrazoEnum[key] === cv);
              this.filtros.statusPrazo = [...this.filtros.statusPrazo, ...statusEnum];
            })
          }
        } else if(this.filtro.campoFiltro == 'Data de Envio') {
          this.filtros.tipoFiltroDataEnvio = this.filtro.filtrarEm;
          this.filtros.dataEnvio = this.filtro.campoValor;
        } else if(this.filtro.campoFiltro == 'Data Leitura') {
          this.filtros.tipoFiltroDataAbertura = this.filtro.filtrarEm;
          this.filtros.dataAbertura = this.filtro.campoValor;
        } else if(this.filtro.campoFiltro == 'Data Venc.') {
          this.filtros.tipoFiltroDataVenc = this.filtro.filtrarEm;
          this.filtros.dataVenc = this.filtro.campoValor;
        } else if(this.filtro.campoFiltro == 'Meu Venc.') {
          this.filtros.tipoFiltroMeuVenc = this.filtro.filtrarEm;
          this.filtros.meuVenc = this.filtro.campoValor;
        } else if(this.filtro.campoFiltro == 'Dias Prazo') {
          this.filtros.tipoFiltroDiasPrazo = this.filtro.filtrarEm;
          this.filtros.diasPrazo = this.filtro.campoValor;
        } else if(this.filtro.campoFiltro == 'Teor da Comunicação') {
          this.filtros.tipoFiltroTeorComunicacao = this.filtro.filtrarEm;
          this.filtros.teorComunicacao = this.filtro.campoValor;
        } else if(this.filtro.campoFiltro == 'Classe Processual') {
          this.filtros.tipoFiltroClasseProcessual = this.filtro.filtrarEm;
          this.filtros.classeProcessual = this.filtro.campoValor;
        } else if(this.filtro.campoFiltro == 'Data Aju.') {
          this.filtros.tipoFiltroDataAju = this.filtro.filtrarEm;
          this.filtros.dataAju = this.filtro.campoValor;
        } else if(this.filtro.campoFiltro == 'Status Grau') {
          this.filtros.tipoFiltroStatusGrau = this.filtro.filtrarEm;
          this.filtros.statusGrau = this.filtro.campoValor;
        } else if(this.filtro.campoFiltro == 'Devedor') {
          this.filtros.tipoFiltroDevedor = this.filtro.filtrarEm;
          this.filtros.devedor = this.filtro.campoValor;
        } else if (this.filtro.campoFiltro == 'Minuta') {
		  this.filtros.minuta = this.filtro.campoValor == null ? null : this.filtro.campoValor == 'Sim';
		} else if (this.filtro.campoFiltro == 'Modelo Utilizado') {
		  this.filtros.tipoFiltroModelo = this.filtro.filtrarEm;
		  this.filtros.modelo = this.filtro.campoValor;
		} else if (this.filtro.campoFiltro == 'Rel. CDAs') {
		  this.filtros.relCdas = this.filtro.campoValor;
		} else if (this.filtro.campoFiltro == 'Anexos') {
		  this.filtros.anexos = this.filtro.campoValor == null ? null : this.filtro.campoValor == 'Sim';
		} else if (this.filtro.campoFiltro == 'Status da Minuta') {
		  this.filtros.statusMinuta = this.filtro.campoValor;
		} else if (this.filtro.campoFiltro == 'ID Aviso') {
		  this.filtros.idAviso = this.filtro.campoValor;
		}
        
        this.consultar();
    },
    ordenarResultados(order) {
      if(this.filtro.campoFiltro == 'CNJ') {
        this.sortField = 'pp.cnj ' + order;
      } else if(this.filtro.campoFiltro == 'Tipo Prazo') {
          this.sortField = 'pp.tipoPrazo ' + order;
      } else if(this.filtro.campoFiltro == 'Status Prazo') {
          this.sortField = 'pp.statusPrazo ' + order;
      } else if(this.filtro.campoFiltro == 'Data de Envio') {
        this.sortField = 'pp.dataHoraDisponibilizacao ' + order;
      } else if(this.filtro.campoFiltro == 'Data Leitura') {
          this.sortField = 'pp.dataAbertura ' + order;
      } else if(this.filtro.campoFiltro == 'Data Venc.') {
          this.sortField = 'pp.dataVencimento ' + order;
      } else if(this.filtro.campoFiltro == 'Meu Venc.') {
          this.sortField = 'pp.dataVencimentoProcurador ' + order;
      } else if(this.filtro.campoFiltro == 'Dias Prazo') {
          this.sortField = 'pp.qtdeDiasPrazo ' + order;
      } else if(this.filtro.campoFiltro == 'Teor da Comunicação') {
          this.sortField = 'pp.teorComunicacao ' + order;
      } else if(this.filtro.campoFiltro == 'Classe Processual') {
          this.sortField = 'cp.descricao ' + order;
      } else if(this.filtro.campoFiltro == 'Data Aju.') {
          this.sortField = 'pp.dataAjuizamento ' + order;
      } else if(this.filtro.campoFiltro == 'Status Grau') {
          this.sortField = 'pp.statusGrau ' + order;
      } else if(this.filtro.campoFiltro == 'Devedor') {
          this.sortField = 'd.nome ' + order;
      } else if (this.filtro.campoFiltro == 'Minuta') {
	      this.sortField = 'peticionamento.minuta ' + order;
      } else if (this.filtro.campoFiltro == 'Modelo Utilizado') {
	      this.sortField = 'modeloPeticao ' + order;
      } else if (this.filtro.campoFiltro == 'Rel. CDAs') {
	      this.sortField = 'peticionamento.gerarMinutaCDA ' + order;
      } else if (this.filtro.campoFiltro == 'Anexos') {
	      this.sortField = 'documento ' + order;
      } else if (this.filtro.campoFiltro == 'Status da Minuta') {
	      this.sortField = 'peticionamento.statusPeticao ' + order;
      } else if (this.filtro.campoFiltro == 'ID Aviso') {
	      this.sortField = 'pp.idAviso ' + order;
      }

    },
    limparFiltros() {
      this.sortField = null;
      this.filtro = {};
      this.filtros = {};
      this.itensSelecionados = [];
      this.consultar(false);
    },
    consultar(manterSelecao = true) {
      this.$refs.agendaPrazosTabelaRef.listarAgendaPrazos(manterSelecao)
    },
    atualizarSelecionados(itens) {
      this.itensSelecionados = itens
    },
	consultarModelos() {
	  this.$refs.agendaPrazosTabelaRef.listarModelos()
	},
    desselecionarPrazos() {
	  this.$refs.agendaPrazosTabelaRef.selecionarRegistrosMinuta()
	},
  },
};
</script>

<style scoped lang="scss">
.background-scroller {
  background: none;
}

table thead th,
.table thead th {
  background: none !important;
}

.btn-group {
  width: 100%;
}

ul,
dl {
  margin-bottom: 0rem !important;
}

li .btn,
td .btn {
  padding: 0;
}

.headerFixo {
  position: fixed;
}

.headerPadrao {
  position: relative;
}

.bg-white {
  background-color: white;
}

.btn .btn-link,
.btn {
  text-align: left;
}

table {
  width: 100%;
}

.ellipsis {
  position: relative;
}

.ellipsis:before {
  content: "&nbsp;";
  visibility: hidden;
}

.ellipsis span {
  position: absolute;
  left: 0;
  right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bloco-fixo {
  position: sticky;
  top: 55px;
  z-index: 1000;
}

.bloco-fixo-abas {
  position: sticky;
  top: 158px;
  z-index: 1000;
}


.botoes-tabelas {
  border-bottom: 2px solid #f1f1f1;

  .btn-prazo {
    background: transparent;
    color: #000;
    text-align: center;
    border-radius: 0.25rem 0 0 0;
    border: none;

    &.active {
      background-color: #cfe2f3;
      color: #004262;
    }
  }

  .btn-processo {
    background: transparent;
    color: #000;
    text-align: center;
    border: none;

    &.active {
      background-color: #f4cccc;
      color: #004262;
    }
  }

  .btn-minuta {
    background: transparent;
    color: #000;
    text-align: center;
    border-radius: 0 0.25rem 0 0;
    border: none;

    &.active {
      background-color: #d8ead2;
      color: #004262;
    }
  }
}
</style>
